module.exports = __webpack_public_path__ + "img/focus-head-bg.b44b211d.jpg";